module.exports = __webpack_public_path__ + "static/media/invoease.734d5bb7.jpg";